import Text from 'components/Text/Text';
import { IPushesViewContext, PushesViewContext } from '../../../../pushesViewContext/pushesViewState/pushesViewContext';
import React, { useContext } from 'react';
import { Pagination } from 'antd';
import style from './UpdateHistoryPagination.module.scss';

const UpdateHistoryPagination: React.FC = () => {
	const { changeCurrentPage, softwareUpdates, currentPage, countOfItems } =
		useContext<IPushesViewContext>(PushesViewContext);

	const from = (currentPage - 1) * Number(countOfItems) + 1;
	const to = currentPage * Number(countOfItems);
	const total = softwareUpdates.count;

	return (
		<div className={style.container} data-test="UpdateHistoryPagination">
			<Text
				className={style.counter}
				translationNameSpace="form"
				translationKey="paginationLabel"
				translationOptions={{
					from,
					to: to < total ? to : total,
					total,
				}}
				size="xs"
			/>
			<Pagination
				current={currentPage}
				pageSize={Number(countOfItems)}
				total={softwareUpdates.count}
				onChange={changeCurrentPage}
				showSizeChanger={false}
			/>
			<div className={style.plug}></div>
		</div>
	);
};

export default UpdateHistoryPagination;
